export default __webpack_public_path__ + "img/news_card.b46f2eae.jpg";